<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        id="loginEmail"
        v-model.trim="form.email"
        :validator="vs.form.email"
        :label="(isAdminLocalization ? adminText('adminAll.email_29e700', 'Email*') : $t('loginFormEmail', 'Email*'))"
        type="email"
        autofocus
      />
    </v-flex>
    <v-flex>
      <text-field
        :admin-context="isAdminLocalization"
        id="loginPassword"
        v-model.trim="form.password"
        :validator="vs.form.password"
        :label="(isAdminLocalization ? adminText('adminAll.password_37d602', 'Password*') : $t('loginFormPassword', 'Password*'))"
        :type="showPasswordInput ? 'text' : 'password'"
        :append-icon="showPasswordInput ? 'visibility_off' : 'visibility'"
        @clickAppendIcon="showPasswordInput = !showPasswordInput"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'login-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showPasswordInput: false,
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped></style>
